import { InputOperadoraSaude } from '../../../../components/InputsAutoComplete'
import React, { useState, useEffect } from 'react'
import Yup, { validaCPF, validaData, validaHora } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { Formik, Form, FieldArray } from 'formik'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens, useWindowSize } from '../../../../util/Utilitarios'
import { useParams } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { salvar, get } from '../../../../util/AcessoApi'
import '../../../../assets/css/icones/iconsmind/style.css';
import Atalho from '../../../../util/Atalho'
import { InputBeneficiarioCentral,  InputEstabelecimentoSaude, InputGrauParentesco, InputTodosProcedimentos } from '../../../../components/InputsAutoCompleteV2'
import { InputCheckboxNullable,   TextArea, InputPadrao, InputPadraoSimples, InputRange } from '../../../../components/InputsV2'

import { TIPO_PERGUNTA } from '../../../../util/Enums'
import { calcularIdade } from '../../../../util/FuncoesComuns'
import { ModalDuasOpcoes } from '../../../../components/Modais'
import ContentLoader from 'react-content-loader'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiAlertTriangle } from 'react-icons/fi'
const CadastroPaciente = (props) => {
    const [width, height] = useWindowSize()
    let { id } = useParams()
    const [refPaciente, setRefPaciente] = useState({})

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({ beneficiario: "", agrupamentos: [], nivel_dor: 0, liberado: false, nao_liberado: false });
    const [showModalConfirmarSalvar, setShowModalConfirmarSalvar] = useState(false);
    const [carregando, setCarregando] = useState(true);
    const [permitido, setPermitido] = useState(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const history = useHistory()
    const agenda_id = history.location.state && history.location.state.agenda_id ? history.location.state.agenda_id : params != null ? params.get('agendaId') : null


    const [validacao] = useState(Yup.object({
        paciente: Yup.object().required().nullable(),
        liberado: Yup.boolean().required().nullable(),
    }));

    const abrirModalConfirmacao = () => {
        setShowModalConfirmarSalvar(true);
    }

    const Submit = (values, propsFormik) => {
        setShowModalConfirmarSalvar(false)
        setSalvando(true)
        salvar(
            { ...values },
            '/preanestesica/formulario',
            obj => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    setSalvando(false)
                } else
                    props.history.push('/preanestesico/consultapreanestesico/consulta')
            },
            (err) => {
                console.log('err: ', err);
                // mostrarToast('erro', mensagens.erro);
                setSalvando(false);
            })
    }

    useEffect(() => { 

        setPermitido(true);  
        
    }, [])

    useEffect(_ => {
        if (permitido) {
            if (agenda_id) {
                Promise.resolve(get(`/preanestesico/obterDadosPorAgenda/${agenda_id}`)).then(obj => {                  
                    setCarregando(false);
                    var { agrupamentos, ...paciente } = obj;
                    paciente.nivel_dor = paciente.nivel_dor || 0;
                    setValoresIniciais({ agrupamentos: agrupamentos, ...paciente });
                }).catch(_ => {
                    setCarregando(false);
                })

            } else
                Promise.resolve(get(`/preanestesico/consultapreanestesico/${id || 0}`)).then(obj => {                    
                    setCarregando(false);
                    var { agrupamentos, ...paciente } = obj;
                    paciente.nivel_dor = paciente.nivel_dor || 0;
                    setValoresIniciais({ agrupamentos: agrupamentos, ...paciente });
                }).catch(_ => {
                    setCarregando(false);
                })
        }
    }, [id, permitido])

    const onChangePressao = (value, propsFormik) => {
        if (value && value.toString().indexOf("/") > -1)
            return;

        let cleaned = value.replace(/\D/g, '');

        if (cleaned.length === 0) {
            propsFormik.setFieldValue('pressao_arterial', ``);
            return;
        }

        let systolic = '';
        let diastolic = '';

        if (cleaned.length <= 1) {
            return cleaned;
        }

        for (let i = 1; i < cleaned.length; i++) {
            let firstPart = cleaned.substring(0, i);
            let secondPart = cleaned.substring(i);

            if (parseInt(firstPart) >= parseInt(secondPart)) {
                systolic = firstPart;
                diastolic = secondPart;
                break;
            }
        }

        if (!systolic || !diastolic) {
            let mid = Math.floor(cleaned.length / 2);
            systolic = cleaned.substring(0, mid);
            diastolic = cleaned.substring(mid);
        }

        propsFormik.setFieldValue('pressao_arterial', `${systolic}/${diastolic}`);
    }

    const onChangeNumberMaxLength = (name, value, maxLength, propsFormik) => {
        if (value?.length > maxLength)
            return null;

        propsFormik.setFieldValue(name, value);
    }

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={abrirModalConfirmacao}>
            {propsFormik => {
                return (<Form>
                    <div className={props.modal && props.modal || 'card mb-20'}>
                        <div className={props.modal || 'card-body'}>
                            <div className='row'>
                                <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' />
                                <InputBeneficiarioCentral
                                    setReference={setRefPaciente}
                                    ref={refPaciente}
                                    label="Paciente"
                                    placeholder="Paciente"
                                    name="paciente"
                                    propsFormik={propsFormik}
                                    obrigatorio={true}
                                    tamanho={'col-4'}
                                    classeTooltip={'tooltip-input-modal'}
                                    focarAposSubmit={true}
                                    salvarENovo={salvarENovo}
                                    autoFocus
                                    botaoVisivel={true}
                                    botaoAlterar={true}
                                    onChange={(value) => {
                                        if (value && value.data_nascimento && value.data_nascimento.length > 0) {
                                            propsFormik.setFieldValue('idade', calcularIdade(value.data_nascimento))
                                        } else {
                                            propsFormik.setFieldValue('idade', '')
                                        }
                                    }}
                                />

                                <InputOperadoraSaude tamanho="col-4" label="Operadora Saúde" name={`operadora_saude`} multiplo={false} placeholder="Operadora Saúde"
                                    propsFormik={propsFormik} />
                                <InputEstabelecimentoSaude tamanho="col-4" label="Estabelecimento Saúde" name={`estabelecimento_saude`} multiplo={false} placeholder="Estabelecimento Saúde"
                                    propsFormik={propsFormik} />
                                <div className='col-4 row m-0'>
                                    <InputPadrao label="Idade" name={`idade`} type='number' placeholder='Idade' tamanho='col-4 pl-0' maxLength={3} onChange={(e) => onChangeNumberMaxLength('idade', e?.target?.value, 3, propsFormik)} />
                                    <InputPadrao label="Altura(CM)" name={`altura`} type='number' placeholder='Altura(CM)' tamanho='col-4' maxLength={3} onChange={(e) => onChangeNumberMaxLength('altura', e?.target?.value, 3, propsFormik)} />
                                    <InputPadrao label="Peso(KG)" name={`peso`} type='number' placeholder='Peso(KG)' tamanho='col-4 pr-0' maxLength={3} onChange={(e) => onChangeNumberMaxLength('peso', e?.target?.value, 3, propsFormik)} />

                                </div>
                                {/* <InputOperadoraSaude tamanho="col-5" label="Operadora Saúde" name={`operadora_saude`} multiplo={false} placeholder="Operadora Saúde"
                                    propsFormik={propsFormik} />
                                <InputEstabelecimentoSaude tamanho="col-5" label="Estabelecimento Saúde" name={`estabelecimento_saude`} multiplo={false} placeholder="Estabelecimento Saúde"
                                    propsFormik={propsFormik} /> */}

                                <InputPadraoSimples label="Pressão Arterial" name="pressao_arterial" tamanho="col-2" placeholder="Pressão Arterial" onBlur={(e) => onChangePressao(e.target.value, propsFormik)} />
                                <InputPadrao label="Frequência Cardíaca" name="frequencia_cardiaca" tamanho="col-2" placeholder="Frequência" type="number" maxLength={3} onChange={(e) => onChangeNumberMaxLength('frequencia_cardiaca', e?.target?.value, 3, propsFormik)} />
                                <InputPadrao label="Jejum Sólidos(h)" name="jejum_solidos_horas" tamanho="col-2" placeholder="Horas" type="number" onChange={(e) => onChangeNumberMaxLength('jejum_solidos_horas', e?.target?.value, 3, propsFormik)} />
                                <InputPadrao label="Jejum Líquidos(h)" name="jejum_liquidos_horas" tamanho="col-2" placeholder="Horas" type="number" onChange={(e) => onChangeNumberMaxLength('jejum_liquidos_horas', e?.target?.value, 3, propsFormik)} />

                                <InputRange
                                    label="Nível de Dor"
                                    name="nivel_dor"
                                    min={0}
                                    max={5}
                                    step={1}
                                    tamanho="col-4"
                                    value={propsFormik.values.nivel_dor}
                                    tooltipContent={["😁", "🙂", "😐", "🙁", "😟", "😫"]}
                                    tooltipClass="primary-tooltip"
                                />

                                {/* <InputPadrao label="Cirurgia/Procedimento" name={`procedimento`} type='text' placeholder='Nome' tamanho='col-6' /> */}
                                <InputTodosProcedimentos label='Cirurgia/Procedimento' name="procedimentos" propsFormik={propsFormik} tamanho="col-8"
                                    {...props} classeTooltip={'tooltip-input-modal'} multiplo={true} />
                                <InputPadrao label="Respondido por" name={`responsavel_nome`} type='text' placeholder='Nome' tamanho='col-6' maxLength={45} />
                                <InputPadrao label="Identificaçao(RG/CPF)" name={`responsavel_identificacao`} type='text' placeholder='RG/CPF' tamanho='col-3' maxLength={18} />
                                <InputGrauParentesco tamanho="col-3" label="Grau Parentesco" name="grau_parentesco" multiplo={false} placeholder="Grau Parentesco"
                                    propsFormik={propsFormik} />

                                {carregando ? <ContentLoader
                                    speed={2}
                                    width={1200}
                                    height={800}
                                    viewBox="0 0 1200 700"
                                    backgroundColor="#f3f3f3"
                                    foregroundColor="#ecebeb"
                                    {...props}
                                >
                                    {/* Título */}
                                    <rect x="20" y="15" rx="4" ry="4" width="350" height="20" />
                                    <rect x="20" y="50" rx="4" ry="4" width="1160" height="200" />
                                </ContentLoader> : <></>}

                                <Formulario propsFormik={propsFormik} ajustarTamanho={width < 1280} />

                                <TextArea
                                    label={"Observações Gerais"}
                                    name={`observacao`}
                                    type="text"
                                    placeholder="Observação"
                                    tamanho={'col-12'}
                                    maxLength={500}
                                />
                                <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                            </div>
                        </div>
                    </div>
                    {!props.modal && <div className='separator mt-40 mb-5'></div>}
                    <div className='direita container-botoes mb-3 group-salvar-novo'>
                        <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                        {/* {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />} */}
                    </div>
                    <ModalDuasOpcoes
                        titulo="Atenção!"
                        showModal={showModalConfirmarSalvar}
                        setShowModal={setShowModalConfirmarSalvar}
                        funcaoOpcao2={() => Submit(propsFormik.values, propsFormik)}
                        funcaoOpcao1={() => {
                            setSalvando(false)
                            setShowModalConfirmarSalvar(false)
                        }}
                        esconderFechar
                        mensagem={'Você confirma que todas as informações fornecidas estão corretas e deseja finalizar o cadastro da consulta?'}
                        textoOpcao1={'Fechar'}
                        classeOpcao1={'btn-sm btn-primary-modal simples'}
                        textoOpcao2={'Continuar'}
                    />
                </Form>)
            }}
        </Formik >
    )
}

const Formulario = ({ propsFormik, questao, ajustarTamanho }) => {
    return <FieldArray name="agrupamentos">
        {arrayHelpers => (
            propsFormik.values.agrupamentos && propsFormik.values.agrupamentos.map((agrupamento, aggIdx, arrAgg) => {
                let ocuparMenos = false;
                let aggLength = arrAgg.length;

                if (agrupamento.questoes && agrupamento.questoes?.length <= 2)
                    if ((aggIdx < (aggLength - 1) && arrAgg[aggIdx + 1].questoes?.length <= 2) || (aggIdx > 0 && arrAgg[aggIdx - 1].questoes?.length <= 2))
                        ocuparMenos = true;

                return <div className={`col-lg-${ocuparMenos ? 6 : 12} margin-top-1 mb-20 p-0 row m-0`}>
                    <div className="display-flex mt-20 col-12"><h4 className='m-0'><span className={"icon-File-ClipboardFileText"}></span> <span>{agrupamento.descricao}</span></h4></div>

                    <div className={`col-12 margin-top-1 mb-20`}>
                        <div className='row row-form'>
                            {
                                agrupamento.questoes?.map((questao, index) => {
                                    let algumSelecionado = questao.opcoes ? questao.opcoes.findIndex(x => x.marcado) : -1;
                                    let naoPreenchido = algumSelecionado > -1 || questao.observacao?.length > 0;

                                    return <div className={`col-${ocuparMenos ? 6 : ajustarTamanho ? 4 : 3} pt-20 p-5rem ${naoPreenchido ? '' : 'bg-primary-gray'}`}>
                                        <div className=''>
                                            <div className='display-flex mb-2 row-space-between'>
                                                <h6 className='mb-0 fs-15'><b>{questao.descricao}</b></h6>
                                                {questao.mostrar_nao_possui ? <InputCheckboxNullable twoOptions={true} disabled={questao.excluido} name={`agrupamentos[${aggIdx}].questoes[${index}].nao_possui`} label={'Negativo'} /> : null}
                                            </div>
                                            <Perguntas prefixName={`agrupamentos[${aggIdx}].`} questao={questao} index={index} propsFormik={propsFormik} aggIdx={aggIdx} disabled={propsFormik.values.agrupamentos[aggIdx].questoes[index].nao_possui} somenteLeitura={questao.excluido} />
                                        </div>
                                    </div>
                                })
                            }
                            {arrAgg.length === aggIdx + 1 ? (
                                <div
                                    className={`col-6 pt-20 p-5rem ${
                                        propsFormik.values.liberado === undefined || propsFormik.values.liberado === null
                                            ? 'bg-primary-gray'
                                            : ''
                                        }`}
                                >
                                    <div>
                                        <div className="display-flex mb-2 row-space-between">
                                            <h6 className="mb-0 fs-15">
                                                <b>Liberado para Cirurgia?</b>
                                            </h6>
                                        </div>
                                        <OverlayTrigger
                                            placement="bottom"
                                            show={propsFormik.touched.liberado && !!propsFormik.errors.liberado}
                                            overlay={
                                                <Tooltip id="tooltip-liberado" className="error-tooltip text-center">
                                                    <div className="error">
                                                        <FiAlertTriangle className="icone" />
                                                        {propsFormik.errors.liberado}
                                                    </div>
                                                </Tooltip>
                                            }
                                        >
                                            <div className="row justify-content-center">
                                                <div className="col-6 text-center">
                                                    <InputCheckboxNullable
                                                        twoOptions={true}
                                                        name="liberado"
                                                        checked={propsFormik.values.liberado === true}
                                                        label="SIM"
                                                        onBlur={propsFormik.handleBlur}
                                                        onChange={() => propsFormik.setFieldValue('liberado', true)}
                                                    />
                                                </div>
                                                <div className="col-6 text-center">
                                                    <InputCheckboxNullable
                                                        twoOptions={true}
                                                        name="liberado"
                                                        checked={propsFormik.values.liberado === false}
                                                        label="NÃO"
                                                        onBlur={propsFormik.handleBlur}
                                                        onChange={() => propsFormik.setFieldValue('liberado', false)}
                                                    />
                                                </div>
                                            </div>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            })
        )}
    </FieldArray >
}

const Perguntas = ({ questao, index, propsFormik, prefixName, aggIdx, disabled, somenteLeitura }) => {
    let opcaoAbrirTextIdx = questao.opcoes ? questao.opcoes.findIndex(x => x.marcado) : -1;

    const onChangeUnicaEscolha = (opIdx) => {
        const allOptions = propsFormik.values?.agrupamentos[aggIdx].questoes[index].opcoes;
        const currentValue = propsFormik.values?.agrupamentos[aggIdx].questoes[index].opcoes[opIdx].marcado;
        propsFormik.setFieldValue(prefixName + `questoes[${index}].opcoes`, allOptions.map(x => ({ ...x, marcado: false })));
        propsFormik.setFieldValue(prefixName + `questoes[${index}].opcoes[${opIdx}].marcado`, !currentValue);
    }

    useEffect(() => {
        if (opcaoAbrirTextIdx == -1 && questao.tipo_pergunta != TIPO_PERGUNTA.COMENTARIO) {
            propsFormik.setFieldValue(prefixName + `questoes[${index}].observacao`, '');
        }
    }, [opcaoAbrirTextIdx])

    useEffect(() => {
        if (disabled == true) {
            let bloco = propsFormik.values?.agrupamentos[aggIdx].questoes[index];
            bloco.observacao = '';
            bloco.opcoes = (bloco.opcoes || []).map(x => ({ ...x, marcado: false }));
            propsFormik.setFieldValue(prefixName + `questoes[${index}]`, bloco);
        }
    }, [disabled])

    switch (questao.tipo_pergunta) {
        case TIPO_PERGUNTA.MULTIPLA_ESCOLHA:
            return <div className='row'>
                {questao.opcoes && questao.opcoes?.map((opcao, opIdx) => {
                    return <div className='col-6'><InputCheckboxNullable twoOptions={true} disabled={disabled || somenteLeitura || opcao.excluido} name={prefixName + `questoes[${index}].opcoes[${opIdx}].marcado`} label={opcao.descricao} />
                    </div>
                })}
                {
                    (opcaoAbrirTextIdx > -1 && questao.opcoes[opcaoAbrirTextIdx]?.marcado) ? <TextArea
                        name={prefixName + `questoes[${index}].observacao`}
                        rows={2}
                        type="text"
                        maxLength={300}
                        placeholder={questao?.placeholder || "Observação/Outros"}
                        tamanho={'col-12'}
                        disabled={disabled || somenteLeitura}
                    /> : <></>
                }
            </div>
        case TIPO_PERGUNTA.COMENTARIO:
            return <TextArea
                name={prefixName + `questoes[${index}].observacao`}
                rows={2}
                type="text"
                maxLength={300}
                placeholder={questao?.placeholder || "Observação/Outros"}
                tamanho={'col-12 p-0'}
                disabled={disabled || somenteLeitura}
            />
        case TIPO_PERGUNTA.UNICA_ESCOLHA:
            return <div className='row'>
                {questao.opcoes && questao.opcoes?.map((opcao, opIdx) => {
                    return <div className='col-6'><InputCheckboxNullable twoOptions={true} disabled={disabled || somenteLeitura || opcao.excluido} name={prefixName + `questoes[${index}].opcoes[${opIdx}].marcado`} label={opcao.descricao} onChange={() => onChangeUnicaEscolha(opIdx)} /></div>
                })}
                {
                    (opcaoAbrirTextIdx > -1 && questao.opcoes[opcaoAbrirTextIdx]?.marcado) ? <TextArea
                        name={prefixName + `questoes[${index}].observacao`}
                        rows={2}
                        maxLength={300}
                        type="text"
                        placeholder={questao?.placeholder || "Observação/Outros"}
                        tamanho={'col-12'}
                        disabled={disabled || somenteLeitura}
                    /> : <></>
                }
            </div>
        default:
            return <></>
    }
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link className='link-active' to={'/preanestesico/consultapreanestesico/consulta'}>Consulta Pré Anestésica</Link>,
    ]
    return (<>
        {!props.modal && <HeaderCadastro titulo={"Cadastro de Consulta Pré-Anestésica"} link={links} />}
        <CadastroPaciente {...props} />
    </>
    )
}
export { CadastroPaciente, Perguntas }
export default Cadastro